import { ActionIcon, Tooltip } from '@mantine/core';
import { useClipboard } from '@mantine/hooks';
import { notifications } from '@mantine/notifications';
import { IconCheck, IconCopy } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

export function CopyButton({
    value,
    label,
    size = 'xs',
}: {
    value: string | null | undefined;
    /** Shown in tooltip, e.g. "email" or "ID" */
    label?: string;
    size?: 'xs' | 'sm';
}) {
    const { t } = useTranslation();
    const clipboard = useClipboard({ timeout: 2000 });

    if (!value?.trim()) {
        return null;
    }

    const tooltip = clipboard.copied
        ? t('common.copy.copied')
        : label
          ? t('common.copy.copyLabel', { label })
          : t('common.copy.copy');

    return (
        <Tooltip label={tooltip} withArrow position="top">
            <ActionIcon
                size={size}
                variant="subtle"
                color={clipboard.copied ? 'teal' : 'gray'}
                aria-label={tooltip}
                onClick={(e) => {
                    e.stopPropagation();
                    clipboard.copy(value);
                    notifications.show({
                        color: 'teal',
                        message: label
                            ? t('common.copy.labelCopied', { label })
                            : t('common.copy.copiedToClipboard'),
                        autoClose: 1500,
                    });
                }}
            >
                {clipboard.copied ? <IconCheck size={14} /> : <IconCopy size={14} />}
            </ActionIcon>
        </Tooltip>
    );
}
